import SyncIcon from '@mui/icons-material/Sync';
import { Box, Tooltip } from '@mui/material';
import Iconify from '../iconify';
import { fCurrency } from '../../utils/formatNumber';
import { fMonthDayTimeYear, fMonthDayYear } from '../../utils/formatTime';
import VendorIdToName from './VendorIdToName';
import { InvoiceVendorSource } from '../../utils/globalEnums';

const getValidDate = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime()) || date.getFullYear() < 2020) return null;
  return date;
};

const name = {
  field: 'name',
  headerName: 'Name',
  minWidth: 100,
  flex: 1,
  type: 'customSelect',
};
const bookingType = {
  field: 'bookingType',
  headerName: 'Booking Type',
  flex: 1,
  type: 'customSelect',
};
const complete = {
  field: 'complete',
  headerName: 'Complete',
  minWidth: 50,
  flex: 0.5,
  align: 'center',
  renderCell: (params) => {
    const { value } = params;
    return value ? <Iconify icon="material-symbols:check-circle-outline" color="primary" /> : <></>;
  },
};
const globalVendor = {
  field: 'globalVendor',
  headerName: 'Global account',
  minWidth: 100,
  flex: 0.7,
  align: 'center',
  renderCell: (params) => {
    const { value } = params;
    return value ? <Iconify icon="material-symbols:check-circle-outline" color="primary" /> : <></>;
  },
};
const orderingDisabled = {
  field: 'orderingDisabled',
  headerName: 'Ordering Disabled',
  flex: 0.5,
  align: 'center',
  renderCell: (params) => {
    const { value } = params;
    return value ? <Iconify icon="material-symbols:check-circle-outline" color="primary" /> : <></>;
  },
};

const paymentTerms = {
  field: 'paymentTerms',
  headerName: 'Payment Terms',
  flex: 0.5,
  align: 'center',
  type: 'customSelect',
  renderCell: (params) => {
    const { value } = params;
    return value;
  },
};

const facility1 = {
  field: 'facility',
  headerName: 'Facility',
  flex: 1,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        // fontSize: '0.8rem',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
};
const facility2 = {
  field: 'facility',
  headerName: 'Name',
  flex: 1,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        // fontSize: '0.8rem',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
};
const group = {
  field: 'group',
  headerName: 'Group',
  flex: 1,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
};
const vendor = {
  field: 'vendor',
  headerName: 'Vendor',
  flex: 1,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        // fontSize: '0.8rem',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
};
const description = {
  field: 'description',
  headerName: 'Description',
  flex: 1,
  minWidth: 100,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        fontSize: '0.7rem',
        display: '-webkit-box',
        WebkitBoxOrient: 'vertical',
        WebkitLineClamp: 3,
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'pre-wrap',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
};
const primaryContact = {
  field: 'primaryContact',
  headerName: 'Primary Contact',
  flex: 1,
  minWidth: 200,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        // fontSize: '0.8rem',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
};
const value = {
  field: 'value',
  headerName: 'Pickup Value',
  minWidth: 100,
  flex: 1.5,
  renderCell: (params) => (
    <Box
      component="div"
      sx={{
        wordWrap: 'break-word',
        whiteSpace: 'pre-wrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        // fontSize: '0.8rem',
      }}
    >
      {params.value}
    </Box>
  ),
  type: 'customSelect',
};

const account = {
  field: 'account',
  headerName: 'Account',
  flex: 1,
  type: 'customSelect',
};

const priceAccount = {
  field: 'priceAccount',
  headerName: 'Price Account',
  flex: 1,
  type: 'customSelect',
};

const area = {
  field: 'area',
  headerName: 'Area',
  flex: 1,
  minWidth: 80,
  type: 'customSelect',
};

const emailTo = {
  field: 'emailTo',
  headerName: 'Po sent to',
  minWidth: 120,
  flex: 1,
  type: 'customSelect',
};
const paymentContact = {
  field: 'emailTo',
  headerName: 'Payment Email Contact',
  minWidth: 120,
  flex: 1,
  type: 'customSelect',
};

const address = {
  field: 'address',
  headerName: 'Address',
  minWidth: 80,
  flex: 1,
  type: 'customSelect',
};
const zip = {
  field: 'zip',
  headerName: 'Zip',
  minWidth: 70,
  flex: 1,
  type: 'customSelect',
};
const city = {
  field: 'city',
  headerName: 'City',
  minWidth: 80,
  flex: 1,
  type: 'customSelect',
};
const state = {
  field: 'state',
  headerName: 'State',
  minWidth: 40,
  flex: 1,
  type: 'customSelect',
};
const phone = {
  field: 'phone',
  headerName: 'Phone',
  minWidth: 60,
  flex: 1,
  type: 'customSelect',
};
const code = {
  field: 'code',
  headerName: 'Code',
  flex: 1,
  type: 'customSelect',
};
const code2 = {
  field: 'code',
  headerName: 'Code',
  flex: 1,
  type: 'customSelect',
  renderCell: (params) => (
    <Box sx={{ display: 'flex', alignItems: 'center' }}>
      <Box>{params.row.code}</Box>
      {!params.row.isNew && (
        <Tooltip title="update existing vendor info">
          <SyncIcon sx={{ color: 'info.main' }} />
        </Tooltip>
      )}
    </Box>
  ),
};
const agoraCode = {
  field: 'agoraCode',
  headerName: 'PS Code',
  flex: 1,
  type: 'customText',
};

const getVendorName = (vendors, vendorId) => {
  const vendor = vendors.find((v) => v.id === vendorId);
  return vendor ? vendor.name : '';
};

export function getVendorIdToName(vendors) {
  return {
    field: 'vendorId',
    headerName: 'Name',
    renderCell: (params) => (
      <Box
        component="div"
        sx={{
          overFlow: 'hidden',
          textOverflow: 'ellipsis',
        }}
      >
        {getVendorName(vendors, params.row.vendorId)}
      </Box>
    ),
    getFilterValues: (row) => [getVendorName(vendors, row.vendorId)],
    valueGetter: (params) => getVendorName(vendors, params.row.vendorId),
    flex: 1,
    minWidth: 120,
    type: 'customSelect',
  };
}

const purchasingVendorIdToName = {
  field: 'purchasingVendorId',
  headerName: 'Name',
  renderCell: (params) => <VendorIdToName vendorId={params.row.purchasingVendorId} />,
  valueGetter: (params) => <VendorIdToName vendorId={params.row.purchasingVendorId} raw />,
  flex: 1,
  type: 'customText',
};

const title = {
  field: 'title',
  headerName: 'Message',
  flex: 1,
  type: 'customSelect',
};
const weekly = {
  field: 'weekly',
  headerName: 'Weekly',
  width: 80,
  renderCell: (params) => {
    const { value } = params;
    return value ? <Iconify icon="material-symbols:check-circle-outline" color="primary" /> : <></>;
  },
};

const biweekly = {
  field: 'biweekly',
  headerName: 'Biweekly',
  width: 80,
  renderCell: (params) => {
    const { value } = params;
    return value ? <Iconify icon="material-symbols:check-circle-outline" color="primary" /> : <></>;
  },
};

const bookingVendor = {
  field: 'bookingVendor',
  headerName: 'Booking Vendor',
  flex: 1,
  type: 'customSelect',
};
const type = {
  field: 'type',
  headerName: 'Type',
  flex: 1,
  minWidth: 70,
  type: 'customSelect',
};
const rule = {
  field: 'rule',
  headerName: 'Rule',
  flex: 1,
  type: 'customSelect',
};
const ruleType = {
  field: 'ruleType',
  headerName: 'Type',
  flex: 1,
  type: 'customSelect',
};
const forFor = {
  field: 'for',
  headerName: 'For',
  flex: 0.7,
  minWidth: 70,
  type: 'customSelect',
};

const dateAdded = {
  field: 'dateAdded',
  headerName: 'Date Added',
  minWidth: 70,
  flex: 0.5,
  type: 'customDate',
  renderCell: (params) => {
    const date = getValidDate(params.value);
    return date ? fMonthDayYear(date) : '';
  },
  valueGetter: (params) => getValidDate(params.value),
};

const cutoffStartDate = {
  field: 'cutoffStartDate',
  headerName: 'Cutoff Start',
  minWidth: 70,
  flex: 0.5,
  type: 'customDate',
  renderCell: (params) => {
    const date = getValidDate(params.value);
    return date ? fMonthDayTimeYear(date) : '';
  },
  valueGetter: (params) => getValidDate(params.value),
};
const cutoffEndDate = {
  field: 'cutoffEndDate',
  headerName: 'Cutoff End',
  minWidth: 70,
  flex: 0.5,
  type: 'customDate',
  renderCell: (params) => {
    const date = getValidDate(params.value);
    return date ? fMonthDayTimeYear(date) : '';
  },
  valueGetter: (params) => getValidDate(params.value),
};
const shipDate = {
  field: 'shipDate',
  headerName: 'Ship Date',
  minWidth: 70,
  flex: 0.5,
  type: 'customDate',
  renderCell: (params) => {
    const date = getValidDate(params.value);
    return date ? fMonthDayYear(date) : '';
  },
  valueGetter: (params) => getValidDate(params.value),
};
const addedBy = {
  field: 'addedBy',
  headerName: 'Added By',
  flex: 0.7,
};
const getSourceLabel = (value) => InvoiceVendorSource[value] ?? '';
const getSourceFilterValues = (row) => {
  const label = getSourceLabel(row.source);
  return [label === '' ? '(Unknown)' : label];
};
const source = {
  field: 'source',
  headerName: 'Source',
  flex: 0.5,
  type: 'customSelect',
  getFilterValues: getSourceFilterValues,
  valueGetter: (params) => InvoiceVendorSource[params.row.source],
  renderCell: (params) => InvoiceVendorSource[params.row.source] || '',
};
const fileType = {
  field: 'fileType',
  headerName: 'Type',
  flex: 0.5,
};
const fileName = {
  field: 'fileName',
  headerName: 'File Name',
  flex: 0.7,
  minWidth: 90,
  renderCell: (params) => (
    <Box sx={{ whiteSpace: 'pre-wrap', overflow: 'hidden', wordWrap: 'break-word' }}>{params.value}</Box>
  ),
};
const minimumTotal = {
  field: 'minimumTotal',
  headerName: 'Minimum Total',

  flex: 0.5,
  type: 'number',
  renderCell: (params) => fCurrency(params.value),
};

const division = {
  field: 'division',
  headerName: 'Division',
  minWidth: 100,
  flex: 0.5,
  type: 'customSelect',
};

const vendorGroup = {
  field: 'vendorType',
  headerName: 'Group',
  minWidth: 100,
  flex: 0.5,
  type: 'customSelect',
};

const INV_API_VENDORS = [name, code2, paymentContact, address, zip, city, state, phone, dateAdded];
const INV_VENDORS = [
  name,
  bookingType,
  code,
  paymentContact,
  address,
  zip,
  city,
  state,
  phone,
  source,
  addedBy,
  dateAdded,
];
const VENDORS = [name, emailTo, address, zip, city, state, phone, dateAdded];
const FACILITY = [facility2, group, vendor, account, priceAccount, paymentTerms];
const MINIMUM = [facility1, vendor, minimumTotal];
const BOOKING = [vendor, bookingVendor, account];
const STATUS = [purchasingVendorIdToName, code, agoraCode];
const EMAIL = [value, type, forFor];
const IGNORED = [value, area];
const NOTES = [description, type, primaryContact, complete];
const EDI = [orderingDisabled];
const SHIPPING_LIST = [vendor, facility1, title, cutoffStartDate, cutoffEndDate, shipDate, weekly, biweekly];
const CXML = [orderingDisabled];
const RULES = [rule, ruleType, vendor];
const FILES = [fileName, fileType, addedBy, dateAdded];
const WAREHOUSE_VENDORS = [name, vendorGroup, division, globalVendor];

export {
  INV_API_VENDORS,
  INV_VENDORS,
  VENDORS,
  FACILITY,
  BOOKING,
  MINIMUM,
  STATUS,
  EMAIL,
  NOTES,
  EDI,
  SHIPPING_LIST,
  RULES,
  FILES,
  CXML,
  IGNORED,
  WAREHOUSE_VENDORS,
};
